import {stringToHTML,generateSelect, generateRank} from "../helper";
import { privacyIcon }  from '~/assets/icons/js/privacyIcon';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            attributes:{
                class:"d-flex fixed-bottom justify-content-center accordion-privacity"
            },
            script: function () {
                let btn = this.querySelector('[data-toggle]');
                let target = this.querySelector(btn.getAttribute('data-target'));
        
                btn.addEventListener('click',()=>{
                  //target.classList.toggle('show');
                  if(btn.getAttribute('aria-expanded') == "true"){
                    btn.setAttribute('aria-expanded',"false");
                    target.style.height="0px";  
                  }else{
                    btn.setAttribute('aria-expanded',"true");
                    target.style.height="478px";
                  }
                });
            },
            components:[
                {
                    tagName:'div',
                    attributes:{
                        "data-slg-type":"C-ACCORDION-PRIVACITY"
                    },
                    classes:['card','text-center'],
                    style:{
                        width:'100%',
                        "max-width":'960px',
                        opacity:1
                    },
                    components:[
                        // Card header
                        {
                            tagName:'div',
                            classes:['card-header','p-0'],
                            components:[
                                {
                                    type:'paragraph',
                                    attributes:{
                                        class:"mb-0",
                                    },
                                    components:[
                                        //Button
                                        {
                                            type:'button',
                                            tagName:'button',
                                            attributes:{
                                                class:"btn btn-link collapsed",
                                                'data-toggle':"collapse",
                                                'data-target':"#collapseThree",
                                                'aria-expanded':"false",
                                                'aria-controls':"collapseThree"
                                            },
                                            style:{
                                                'font-size': '11px',
                                                width: '100%',
                                                color: '#5a5b5c',
                                                'text-decoration': 'none',
                                            },
                                            content:"Información Básica sobre Protección de Datos Personales"

                                        }
                                    ]
                                }
                            ]
                            
                        },
                        {
                            tagName:'div',
                            attributes:{
                                id:"collapseThree",
                                class:"collapse show",
                                'aria-labelledby':"headingThree",
                                'data-parent':"#accordionPrivacy"
                            },
                            style:{
                                transition:'height .35s ease',
                                height:"0px"
                            },
                            components:[
                                {
                                    tagName:'div',
                                    attributes:{
                                        class:"card-body",
                                    },
                                    style:{
                                        'font-size': '11px'
                                    },
                                    components:[
                                        // Row 1
                                        {
                                            tagName:'div',
                                            attributes:{
                                                class:"row",
                                            },
                                            components:[
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-3",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:"strong",
                                                                    content:"Responsable del Tratamiento"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-8",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            attributes:{
                                                                class:"mb-0",
                                                            },
                                                            content:"MEDIA ADGO, S.L"
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            attributes:{
                                                                class:"mb-0",
                                                            },
                                                            content:"C/ del Consell de Cent, 357-359 1ºA, 08007 Barcelona"
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            attributes:{
                                                                class:"mb-0",
                                                            },
                                                            content:"933 48 74 12"
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            content:"usuario@mediaadgo.com"
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-1",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    type:'link',
                                                                    attributes:{
                                                                        target:"_blank",
                                                                        href:"https://wikiliky.com/politica-de-privacidad/"
                                                                    },
                                                                    content:"+info"

                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },

                                            ]
                                        },
                                        // Row 2
                                        {
                                            tagName:'div',
                                            attributes:{
                                                class:"row",
                                            },
                                            components:[
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-3",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:"strong",
                                                                    content:"Finalidad"
                                                                }
                                                            ]
                                                        },
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-8",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'b',
                                                                    content:' I.'
                                                                },
                                                                {
                                                                    tagName:'span',
                                                                    content:'Gestión de la participación en sorteos, concursos y/o promociones.'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'b',
                                                                    content:'II.'
                                                                },
                                                                {
                                                                    tagName:'span',
                                                                    content:'Envío de comunicaciones comerciales o estudios de mercado.'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'b',
                                                                    content:'III.'
                                                                },
                                                                {
                                                                    tagName:'span',
                                                                    content:'Cesión de datos a terceros para el envío de acciones publicitarias o estudios de mercado.'
                                                                }
                                                            ]
                                                        }        
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-1",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    type:'link',
                                                                    attributes:{
                                                                        target:"_blank",
                                                                        href:"https://wikiliky.com/politica-de-privacidad/"
                                                                    },
                                                                    content:"+info"

                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },

                                            ]
                                        },
                                        // Row 3
                                        {
                                            tagName:'div',
                                            attributes:{
                                                class:"row",
                                            },
                                            components:[
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-3",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:"strong",
                                                                    content:"Legitimación"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-8",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'b',
                                                                    content:' I.'
                                                                },
                                                                {
                                                                    tagName:'span',
                                                                    content:'Gestión de la relación contractual.'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'b',
                                                                    content:'II.'
                                                                },
                                                                {
                                                                    tagName:'span',
                                                                    content:'Consentimiento expreso.'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'b',
                                                                    content:'III.'
                                                                },
                                                                {
                                                                    tagName:'span',
                                                                    content:'Consentimiento expreso.'
                                                                }
                                                            ]
                                                        } 
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-1",
                                                    },
                                                    components:[
                                                        {
                                                            type:'link',
                                                            attributes:{
                                                                target:"_blank",
                                                                href:"https://wikiliky.com/politica-de-privacidad/"
                                                            },
                                                            content:"+info"

                                                        },
                                                    ]
                                                },

                                            ]
                                        },
                                        // Row 4
                                        {
                                            tagName:'div',
                                            attributes:{
                                                class:"row",
                                            },
                                            components:[
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-3",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:"strong",
                                                                    content:"Destinatarios"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-8",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            content:'Empresas, organizaciones y/o entidades interesadas en remitirte acciones publicitarias o realizar estudios de mercado tras recabar tu consentimiento para ello independientemente dónde se ubiquen físicamente.'
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-1",
                                                    },
                                                    components:[
                                                        {
                                                            type:'link',
                                                            attributes:{
                                                                target:"_blank",
                                                                href:"https://wikiliky.com/politica-de-privacidad/"
                                                            },
                                                            content:"+info"

                                                        }
                                                    ]
                                                },

                                            ]
                                        },
                                        // Row 5
                                        {
                                            tagName:'div',
                                            attributes:{
                                                class:"row",
                                            },
                                            components:[
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-3",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:"strong",
                                                                    content:"Derechos"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-8",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            content:'Acceso, rectificación, cancelación, oposición, limitación del tratamiento, portabilidad de datos.'
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-1",
                                                    },
                                                    components:[
                                                        {
                                                            type:'link',
                                                            attributes:{
                                                                target:"_blank",
                                                                href:"https://wikiliky.com/politica-de-privacidad/"
                                                            },
                                                            content:"+info"

                                                        }
                                                    ]
                                                },

                                            ]
                                        },
                                        // Row 6
                                        {
                                            tagName:'div',
                                            attributes:{
                                                class:"row",
                                            },
                                            components:[
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-3",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:"strong",
                                                                    content:"Información detallada"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    tagName:"div",
                                                    attributes:{
                                                        class:"col-8",
                                                    },
                                                    components:[
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'span',
                                                                    content:'Puede consultar aquí información detallada sobre la protección de sus datos en nuestra '
                                                                },
                                                                {
                                                                    type:'link',
                                                                    attributes:{
                                                                        target:"_blank",
                                                                        href:"https://wikiliky.com/politica-de-privacidad/"
                                                                    },
                                                                    content:"Política de Privacidad"
        
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            type:'paragraph',
                                                            components:[
                                                                {
                                                                    tagName:'span',
                                                                    content:'Vea también nuestro Aviso legal '
                                                                },
                                                                {
                                                                    type:'link',
                                                                    attributes:{
                                                                        target:"_blank",
                                                                        href:"https://wikiliky.com/politica-de-privacidad/"
                                                                    },
                                                                    content:"aquí"
        
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },

                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]    
                }
              
            ]
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-ACCORDION-PRIVACITY")
                    return { type:'C-ACCORDION-PRIVACITY' }
          }
    });

    DOMC.addType('C-ACCORDION-PRIVACITY', {
      model,
      view:VIEW,
    });

    BM.add('B-PRIVACITY', {
        label:"PRIVACY POLICIES",
        content: { 
            type: 'C-ACCORDION-PRIVACITY',
        },
        category:"ADVANCE COMPONENT",
        media: privacyIcon,
    });
};